const MEETING_LINKS_API = (
  process.env.REACT_APP_MEETING_LINKS_API_URL ||
  "https://apibiz.iid.org.in/api/meeting-links"
).replace(/\/$/, "");

/**
 * Ask Biz CRM whether this meeting ID was created there.
 * GET /api/meeting-links/exists/:meetingId → { exists: true|false }
 */
export async function checkMeetingExists(meetingId) {
  const id = String(meetingId || "").trim();
  if (!id) {
    return { exists: false };
  }

  const url = `${MEETING_LINKS_API}/exists/${encodeURIComponent(id)}`;
  const res = await fetch(url, {
    method: "GET",
    headers: { Accept: "application/json" },
  });

  if (!res.ok) {
    throw new Error("Could not verify this meeting ID. Please try again.");
  }

  const data = await res.json();
  return { exists: Boolean(data?.exists) };
}
